import { motion } from "framer-motion";
import { Check, ArrowRight, Star } from "lucide-react";
import { scrollToId } from "@/hooks/useLenis";

const packages = [
  {
    level: "Nivel 1",
    title: "Formalización de Negocio",
    price: "¢300.000",
    featured: false,
    features: [
      "Constitución de Sociedad",
      "Libros Legales",
      "Composición Accionaria",
      "Personería Jurídica",
      "Flujo de Efectivo Proyectado",
      "Inscripción en Hacienda",
    ],
  },
  {
    level: "Nivel 2",
    title: "Formalización de Negocio",
    price: "¢485.000",
    featured: true,
    features: [
      "Todo lo del Nivel 1",
      "Trámite Pymes",
      "Apertura de 2 Cuentas de Banco",
      "Apertura como Patrono en CCSS",
      "Póliza RT del INS",
      "Permiso de funcionamiento Ministerio de Salud *",
      "Trámite de Patente Municipal *",
    ],
  },
];

const fade = {
  hidden: { opacity: 0, y: 50 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] } }),
};

export const Formalizacion = () => {
  return (
    <section id="formalizacion" className="relative py-28 sm:py-36 bg-vnavy overflow-hidden">
      <div className="absolute -top-20 right-0 w-[500px] h-[500px] bg-vteal/10 rounded-full blur-[160px] pointer-events-none" />
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-vteal-light" />
            <span className="text-sm uppercase tracking-[0.3em] text-vteal-light font-semibold">Formalización de Negocio</span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight text-white leading-tight">
            Constituya su empresa con respaldo profesional
          </h2>
          <p className="mt-6 text-gray-400 leading-relaxed">
            Elija el paquete que mejor se ajusta a su etapa. Nosotros nos encargamos de cada trámite para que su negocio opere formalmente desde el primer día.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 items-start">
          {packages.map((p, i) => (
            <motion.div
              key={p.level}
              custom={i}
              variants={fade}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`formalizacion-card-${i + 1}`}
              className={`relative rounded-2xl p-8 sm:p-10 flex flex-col ${
                p.featured
                  ? "bg-vnavy-800 border border-vteal-light/40 shadow-[0_0_45px_rgba(20,184,166,0.15)]"
                  : "bg-vnavy-800 border border-white/10"
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3 right-8 flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] font-semibold text-vnavy bg-vteal-light rounded-full px-4 py-1.5">
                  <Star className="h-3 w-3 fill-vnavy" /> Más completo
                </span>
              )}

              <span className="text-xs uppercase tracking-[0.25em] text-vteal-light font-semibold mb-3">{p.level}</span>
              <h3 className="font-serif text-2xl sm:text-3xl text-white">{p.title}</h3>

              <div className="mt-6 mb-8 flex flex-col gap-1">
                <span className="font-serif text-5xl sm:text-6xl text-white tracking-tight">{p.price}</span>
                <span className="text-gray-500 text-xs">13% IVA no incluido</span>
              </div>

              <ul className="space-y-3.5 mb-10 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-gray-300 text-sm leading-relaxed">
                    <span className="mt-0.5 h-5 w-5 rounded-full bg-vteal/20 flex items-center justify-center shrink-0">
                      <Check className="h-3 w-3 text-vteal-light" />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>

              {p.featured && (
                <p className="text-xs text-gray-500 mb-4 -mt-4">* Aplica Restricciones</p>
              )}

              <button
                onClick={() => scrollToId("contacto")}
                data-testid={`formalizacion-cta-${i + 1}`}
                className={`w-full flex items-center justify-center gap-2 rounded-full px-6 py-4 font-semibold transition-colors duration-300 ${
                  p.featured
                    ? "bg-vteal-light text-vnavy hover:bg-white"
                    : "border border-white/20 text-white hover:border-vteal-light hover:text-vteal-light"
                }`}
              >
                Solicitar este paquete
                <ArrowRight className="h-4 w-4" />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
